import { useTranslation } from "react-i18next";

import { useCurrentDate } from "../../../store/current-date/current-date.selectors";

import { IconSprite } from "../../ui/IconSprite/IconSprite";

import { Container } from "../Сontainer/Container.styled";
import { FooterWrapper, StyledLink, Text, Wrapper } from "./Footer.styled";

const Footer = () => {
  const { t } = useTranslation();

  const currentDateString = useCurrentDate();
  const currentDate = new Date(currentDateString);
  const currentYear = currentDate.getFullYear();

  return (
    <FooterWrapper>
      <Container>
        <Wrapper>
          <StyledLink to="/">
            <IconSprite tag="anonymizerText" />
          </StyledLink>

          <Text>{`© ${currentYear} ${t("global.rights")}`}</Text>
        </Wrapper>
      </Container>
    </FooterWrapper>
  );
};

export { Footer };
